function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "@font-face { font-family: element-icons; src: url(\"chrome-extension://moombeodfomdpjnpocobemoiaemednkg/fonts/element-icons.woff\") format(\"woff\"), url(\"chrome-extension://moombeodfomdpjnpocobemoiaemednkg/fonts/element-icons.ttf \") format(\"truetype\"); }\n"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M680.226133 570.094933L393.984 190.976 119.790933 382.464a55.261867 55.261867 0 0 0-12.1856 78.967467l176.810667 230.656 395.810133-121.992534z",
  fill: "#0668CA",
  "p-id": 2400
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M680.226133 570.094933L393.984 190.976l223.061333-148.224a57.821867 57.821867 0 0 1 79.837867 15.786667l175.957333 260.744533-192.6144 250.811733z",
  fill: "#0050A0",
  "p-id": 2401
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M872.925867 319.3856l-0.136534-0.273067v0.273067h0.136534zM576.273067 251.904a70.434133 70.434133 0 0 1 47.752533-36.181333l156.552533-33.211734L687.786667 44.987733a61.661867 61.661867 0 0 0-63.0272-25.873066L268.629333 91.2384l220.7232 326.912 86.920534-166.2464z",
  fill: "#DCEDFF",
  "p-id": 2402
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M346.606933 336.9472l142.370134 81.8176 0.375466-0.6144L268.629333 91.2384 94.173867 379.733333a61.3888 61.3888 0 0 0 3.857066 69.137067l59.4432 77.602133 130.440534-177.066666a44.9024 44.9024 0 0 1 58.692266-12.4416z m142.9504 82.2784l0.273067-0.273067-0.426667 0.136534 0.1536 0.136533z m-205.141333 272.861867l9.728-13.056-9.728 12.936533v0.119467zM892.8768 158.634667l-112.298667 23.876266 92.16 136.533334 42.274134-136.157867a19.029333 19.029333 0 0 0-22.135467-24.234667z",
  fill: "#8AC5FF",
  "p-id": 2403
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M624.0256 215.722667a70.724267 70.724267 0 0 0-47.752533 36.181333l-87.04 166.2464 0.375466 0.6144 382.976-99.4816v-0.238933l-92.125866-136.6528-156.433067 33.314133z",
  fill: "#CAC134",
  "p-id": 2404
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M624.0256 215.722667a70.724267 70.724267 0 0 0-47.752533 36.181333l-87.04 166.2464 0.375466 0.6144 382.976-99.4816v-0.238933l-92.125866-136.6528-156.433067 33.314133z",
  fill: "#8AC5FF",
  "p-id": 2405
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M128 566.1184a32.768 32.768 0 0 0 11.0592 48.503467l145.237333 77.4656v-0.119467L157.354667 526.336 128 566.101333z",
  fill: "#59ACFF",
  "p-id": 2406
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M488.8576 419.157333l0.119467-0.256-142.370134-81.8176a45.0048 45.0048 0 0 0-58.709333 12.288L157.354667 526.336l126.976 165.632 9.813333-12.936533 195.362133-260.010667-0.256-0.119467-0.375466 0.238934z",
  fill: "#FFBA3B",
  "p-id": 2407
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M488.8576 419.157333l0.119467-0.256-142.370134-81.8176a45.0048 45.0048 0 0 0-58.709333 12.288L157.354667 526.336l126.976 165.632 9.813333-12.936533 195.362133-260.010667-0.256-0.119467-0.375466 0.238934z",
  fill: "#59ACFF",
  "p-id": 2408
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M617.0624 738.7136L305.8176 842.922667a25.941333 25.941333 0 0 1-34.2016-27.101867l12.8-123.733333 395.810133-121.992534-17.408 117.76a70.280533 70.280533 0 0 1-45.755733 50.858667z",
  fill: "#59ACFF",
  "p-id": 2409
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M936.004267 308.599467l-131.4304 150.954666a169.4208 169.4208 0 0 1-30.72 29.713067l-93.866667 81.066667 192.6144-250.914134 52.462933-24.490666c8.704-4.113067 16.896 6.212267 10.939734 13.6704z",
  fill: "#59ACFF",
  "p-id": 2410
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M209.442133 922.282667c0 44.817067 139.554133 81.152 311.688534 81.152 172.1344 0 311.671467-36.334933 311.671466-81.152 0-44.8-139.537067-81.134933-311.671466-81.134934s-311.688533 36.334933-311.688534 81.134934z",
  fill: "#A4BBD1",
  opacity: 0.6,
  "p-id": 2411
});

var SvgEmpty = function SvgEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1594806946143,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 2399,
    width: 200,
    height: 200,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty.82abfdca.svg";
export { ForwardRef as ReactComponent };